<template>
  <div class="inners">
    <div class="right">
      <div class="titles">{{ $t('common.team.station.detail') }}</div>
      <div><span :class="['line_title', langClass]">{{ $t('common.position.status') }}</span>
        <span class="txt">
          {{
            $t('displace.a', {number: mailWorkPosition?.totalPosition})
          }}
        </span>
      </div>
      <div style="display: flex;justify-content:flex-start;margin-top: 10px;">
        <span :class="['line_title', langClass]">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('common.bh') }}</span>
        <span class="content_text">
          <ul style="list-style: none;">
            <li v-for="(item,index) in mailWorkPosition?.mailContainDataVoList" :key="item">
              <div>
                <span>{{ $t("displace.a", {number: item.containData ?? 0}) }}</span>
               <span style="margin: 0px 6px;">-</span>
                <span v-if="item.free">
                  {{ `${$t('common.mf')}` }}
                </span>
                <span v-else>
                  <span>{{ $t(productSortSwitch(item.productSort * 1)) }}</span>
                  <span>（{{
                      toISODateTime(item.startTime)
                    }}</span>
                  <span> ~ </span>
                  <span>{{
                      toISODateTime(item.endTime)
                    }}）</span>
                </span>
              </div>
            </li>
          </ul>
        </span>
      </div>
      <div style="margin-top: 10px;">
        <span :class="['line_title', langClass]">{{ $t('common.position.use') }}</span>
        <span class="txt">{{ $t('displace.a', {number: mailWorkPosition?.usePosition}) }}</span>
      </div>
      <div style="margin-top: 10px;"><span :class="['line_title', langClass]">{{
          $t('common.position.sheng.yu')
        }}</span>
        <span class="txt">{{ $t('displace.a', {number: mailWorkPosition?.freePosition}) }}</span>
      </div>
      <div>
        <div class="top_title">
          <!--          <div style="font-size: 14px;font-weight: normal">-->
          <!--            {{-->
          <!--              $t('displace.team.station.totalandsurplus', {-->
          <!--                total: mailWorkPosition.totalPosition,-->
          <!--                surplus: mailWorkPosition.freePosition-->
          <!--              })-->
          <!--            }}-->
          <!--          </div>-->
          <el-button size="small" @click="checkoutAll" style="border: none !important;">{{
              $t('common.plxf')
            }}
          </el-button>
        </div>
        <div style="margin-top: 20px">
          <el-table :data="tableData"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                    :cell-style="rowClassName"
                    :header-cell-style="headerClassName"
          >
            <el-table-column type="selection" width="40" :selectable="checkSelectable"/>
            <el-table-column v-for="item in column_values" :prop="item.value" :label="item.key"
                             :width="handleClickSelectWidth(item)"
                             :min-width="handleClickSelectMinWidth(item)"
                             :show-overflow-tooltip="(item.value==='teamName'||item.value==='userName')?true:false"
            >

              <template #default="{row,column,$index}">
                <template v-if="item.value==='status'">
                  <el-button link type="success" v-if="row.status===1">{{ $t('common.kx') }}</el-button>
                  <el-button link type="danger" v-else>{{ $t('common.zy') }}</el-button>
                </template>
                <template v-else-if="item.value==='expireTime'">
                  {{ row.isModify === 1 ? $t('common.yjmf') : row.expireTime }}
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.cz')" :width="160">
              <template #default="{ row, column, $index }">
                <el-button v-if="row.isModify === 0" type="danger" link @click="handleRenewal(row)">
                  {{ $t('common.ph11') }}
                </el-button>
                <el-button type="info" link v-if="row.isModify === 1" :disabled="true">{{ $t('common.mf') }}</el-button>
                <el-button type="primary" link @click="removeToWhere(row)">
                  {{ $t('common.qyz') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pages">
            <el-pagination
                size="small"
                v-model:current-page="current"
                v-model:page-size="size"
                background
                layout="total, prev, pager, next"
                v-if="totals"
                :total="totals"
                @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
    <Dialog
        v-model="dialogVisibleTips"
        :title="$t('common.qygw')"
        :width="'450'"
        :dialogVisible="dialogVisibleTips"
        :isHeadLine="false"
        @update:dialogVisible="(val) => (dialogVisibleTips = val)"
    >
      <template #content>
        <div class="innerbox">
          <span>{{ $t('common.qyz') }}</span>
          <div style="margin-top: 10px">
            <el-select
                size="small"
                v-model="valueStation"
                class="m-2"
                :placeholder="$t('station.select.position')"
                style="width: 240px"
            >
              <el-option
                  v-for="item in optionsStation"
                  :key="item.id"
                  :label="item.workCode"
                  :value="item.workCode"
              />
            </el-select>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="setting_center">
          <el-button size="small" @click="dialogVisibleTips = false">{{ $t('common.sss16') }}</el-button>
          <el-button size="small" type="primary" @click="moveWorkPositionApis">{{ $t('common.confirm') }}</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue'
import {ElMessage, ElTable} from 'element-plus'
import {useRouter} from 'vue-router'
import {getFreeWorkPosition, moveWorkPosition, queryWorkPosition} from "@/api/usercenter";
import {useStore} from "vuex";
import Dialog from "@/components/Dialog.vue";
import {i18n} from "@/lang";
import {flexWidth} from "@/utils/tableWidth";
import {isEmpty} from "@/utils/mylodash";
import {spaceSizeFormat} from "@/utils/file";
import {productSortSwitch} from "@/utils/util";
import dayjs from "dayjs";
import {convertDateList, toISODate, toISODateTime} from "@/views/Home/utils";
import sessionStore from "@/utils/sessionStore";

const router = useRouter();
const store = useStore()
const tableData = ref([])
const column_values = [
  {
    key: i18n.global.t('common.station.number'), value: 'workCode',
  },
  {key: i18n.global.t('common.zt'), value: 'status'},
  {key: i18n.global.t('common.sxsj'), value: 'effectiveTime'},
  {
    key: i18n.global.t('common.endtime'),
    value: 'expireTime'
  },
  {key: i18n.global.t('common.sstd'), value: 'teamName'},
  {key: i18n.global.t('common.sszh'), value: 'userName'}]

const dialogVisibleTips = ref(false)
// 批量选中的值
const selection = ref([])
const loading = ref(false)
// 工位信息
const mailWorkPosition = computed(() => store.state.user.mailWorkPosition)
const userInfo = computed(() => store.state.user.userInfo)
const handleSelectionChange = (val) => {
  selection.value = val;
}

// 分页
const current = ref(1);
const size = ref(10);
const totals = ref(10)
const handleCurrentChange = async (page) => {
  current.value = page;
  await queryWorkPositionApis()
};

// 批量续费
const allProductList = computed(() => store.state.buystorage.allProductList)
const checkoutAll = () => {
  if (selection.value.length === 0) {
    ElMessage.error(i18n.global.t('common.please.select'))
    return
  }

  const result = selection.value.map(item => item.id)
  store.commit("buystorage/setRowTable", selection.value)
  // 工位的批量续费
  const findTarget = allProductList.value.find(item => item.productSort === 1)
  const {id, productSort} = findTarget

  router.push({
    path: '/personal/buystorage',
    query: {Renewal: 1, arr: result.join(','), indexId: id, productSort: productSort, type: 2}
  })
}
// 单行续费
const handleRenewal = (row) => {
  store.commit("buystorage/setRowTable", [row])
  router.push({path: '/personal/buystorage', query: {Renewal: 1, arr: row.id, type: 2}})
}

// 获取工位list
const queryWorkPositionApis = async () => {
  loading.value = true
  const res = await queryWorkPosition({
    userId: userInfo.value.id,
    pageNo: current.value,
    pageSize: size.value,
  })
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return
  }
  const {records} = res.result;
  tableData.value = records;
  current.value = res.result.current;
  size.value = res.result.size;
  totals.value = res.result.total;
  loading.value = false;
}
// 工位列表
const optionsStation = ref([])
// 选中的工位
const valueStation = ref('')
const teamId = computed(() => store.state.email.teamID)
const getFreeWorkPositionApis = async () => {
  const res = await getFreeWorkPosition()
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  optionsStation.value = res.result
}
// 选中的item
const targetCheckItem = ref({})
const removeToWhere = async (row) => {
  dialogVisibleTips.value = true;
  targetCheckItem.value = row
}

const moveWorkPositionApis = async () => {

  const res = await moveWorkPosition({
    newWorkCode: valueStation.value,
    oldWorkCode: targetCheckItem.value.workCode,
  })
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  ElMessage.success(res.message)
  valueStation.value = ''
  dialogVisibleTips.value = false;
  await queryWorkPositionApis()
}

const checkSelectable = (row, index) => {
  return row.isModify !== 1
}


onMounted(async () => {
  if (isEmpty(allProductList.value)) {
    await store.dispatch("buystorage/getMailProductListApis", 1)
  }
  await store.dispatch("user/getPositionByLoginList");
  await queryWorkPositionApis()
  await getFreeWorkPositionApis()
  // await store.dispatch("cloud/queryByUserIdApis");
})


const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  // console.log(row, columnIndex)
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 7) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 7) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

const handleClickSelectWidth = (item) => {
  if (item.value === "effectiveTime") {
    return 180;
  } else if (item.value === "workCode") {
    return lang.value !== 'zh-CN' ? 150 : 100;
  } else if (item.value === "customerType") {
    return flexWidth('customerType', tableData, i18n.global.t('common_customer_type')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerType', tableData, i18n.global.t('common_customer_type'))
  } else if (item.value === 'customerOrigin') {
    return flexWidth('customerOrigin', tableData, i18n.global.t('common.customer.source')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerOrigin', tableData, i18n.global.t('common.customer.source')) + 30
  } else if (item.value === 'createName') {
    return flexWidth('createName', tableData, i18n.global.t('common.byinput')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('createName', tableData, i18n.global.t('common.byinput'))
  } else if (item.value === 'status') {
    return 120;
  } else if (item.value === 'expireTime') {
    return 150;
  } else if (item.value === 'lastTime' || item.value === 'applyTime' || item.value === 'followTime') {
    return 150;
  } else if (item.value === 'setting' || item.value === 'auditStatus') {
    return 120;
  } else {
    return "auto"
  }
}

const handleClickSelectMinWidth = (item) => {
  if (item.value === "workCode") {
    return 150;
  } else {
    return "auto";
  }
}


const lang = computed(() => store.state.system.langLocal)
const langClass = computed(() => {
  return lang.value !== 'zh-CN' ? 'lang-en' : 'lang-zh'
})
</script>

<style lang="less" scoped>
@import "./less/Tables.less";
@import "../../less/page.less";

.inners {
  width: auto !important;
  max-width: 1200px !important;

  .right {
    height: auto !important;
    min-height: 640px !important;
    padding-bottom: 20px !important;
  }
}

:deep(.el-dropdown-menu) {
  background: red;
}

.top_title {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .el-button {
    width: 130px;
    height: 30px;
    background: #d93737;
    font-size: 14px;
    color: #fff;
  }
}

.setting_center {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}


.line_title {
  font-family: PingFangSC, PingFang SC;
  display: inline-block;
  width: max-content;
  min-width: 80px;
  color: #999;
  font-size: 14px;
}

.line_title.lang-zh {
  min-width: 80px;
}

.line_title.lang-en {
  text-align: right;
  min-width: 120px;
}

.txt {
  display: inline-block;
  color: #333;
  font-size: 14px;
  margin-left: 10px;
}

.results {
  width: 100%;
  border-top: 1px solid #e8e8e8;
  height: 53px;
  bottom: 0px;
  left: 0px;
  position: absolute;
  display: flex;
  justify-content: space-between;

  .buttons_pays {
    padding: 0 35px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: #d93737;
    margin-left: auto;
    cursor: pointer;
  }
}

.content_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  margin-left: 10px;

  li {
    div {
      margin-bottom: 10px !important;
    }
  }
}
</style>
